var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPulseFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.33301 4.08301V12.2497",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.85827 2.28005C4.93022 1.2979 3.4129 1.87334 2.65633 2.4612C2.51995 2.56716 2.45176 2.62014 2.39239 2.74147C2.33301 2.86281 2.33301 2.97581 2.33301 3.2018V8.59361C2.89867 7.95328 4.59564 6.9608 6.85827 8.11335C8.88034 9.1434 10.6012 8.7164 11.4153 8.27138C11.5283 8.20966 11.5847 8.17874 11.6256 8.10997C11.6663 8.04119 11.6663 7.96653 11.6663 7.81719V3.42644C11.6663 2.94314 11.6663 2.70149 11.5512 2.61395C11.4361 2.52641 11.1668 2.60108 10.6281 2.75044C9.70634 3.00603 8.36602 3.0481 6.85827 2.28005Z",
    stroke: "var(--stroke-0, #8A6CC8)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulseFlag);
export default __webpack_public_path__ + "static/media/pulse-flag.b191fb07016784a72f7e569d5328a321.svg";
export { ForwardRef as ReactComponent };